module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8003.9fd5e414.png";